define("settings/components/subscription-overview/action", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Section::ItemAction data-test-id="subscription-overview-action">
    {{#if @isAccountOwner}}
      {{#if @subscription.id}}
        {{#if (and @hasActiveTrial (not @hasActiveCancelledSubscription))}}
          {{#if @canShowCancelTrial}}
            <Shared::Ui::Button
              @additional="block"
              @onClick={{@cancelTrial}}
              @text={{t "account.overview.subscription_overview.cancel_trial"}}
              @variant="outline"
              class="u--m__b__lg u--m__t__md u--m__r"
            />
          {{/if}}
        {{else if (and @hasActiveCancelledSubscription @canReactivatePlan)}}
          <Shared::Ui::Button
            @additional="block"
            @promise={{@reactivatePlan}}
            @text={{t "account.overview.subscription_overview.reactivate_plan"}}
            @variant="proceed"
            class="u--m__b__lg u--m__t__md u--m__r"
          />
          {{#if @isNewSubscriber}}
            <Shared::Link
              @href="https://later.com/product-training/"
              @text={{t "account.overview.subscription_overview.help"}}
              class="u--m__r u--text--right u--block u--p__t"
              {{on "click" @trackClickedTraining}}
            />
          {{/if}}
        {{else if @canUpgrade}}
          <Shared::Button::Upgrade
            @feature={{"plans"}}
            @location="subscription overview"
            @text={{t "shared_phrases.upgrade_plan"}}
            class="u--m__r qa--settings__button--upgrade"
          />
        {{else}}
          <Shared::Button::Upgrade
            @feature="plans"
            @location="subscription overview"
            @text={{t "account.overview.subscription_overview.change_plan"}}
            @variant="outline"
            class="u--m__r qa--subscription__button--changePlan"
            {{on "click" @trackChangePlan}}
          />
        {{/if}}
      {{else}}
        <Shared::Button::Upgrade
          @feature={{if @isFreeEligibleForTrial "trialPlansSnapshot" "plans"}}
          @location="subscription overview"
          @text={{t "shared_phrases.upgrade_plan"}}
          class="u--m__r qa--settings__button--upgrade"
        />
      {{/if}}
    {{/if}}
  </Section::ItemAction>
  */
  {
    "id": "30keOc3x",
    "block": "[[[8,[39,0],[[24,\"data-test-id\",\"subscription-overview-action\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,1],[[[41,[30,2,[\"id\"]],[[[41,[28,[37,2],[[30,3],[28,[37,3],[[30,4]],null]],null],[[[41,[30,5],[[[1,\"          \"],[8,[39,4],[[24,0,\"u--m__b__lg u--m__t__md u--m__r\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,6],[28,[37,5],[\"account.overview.subscription_overview.cancel_trial\"],null],\"outline\"]],null],[1,\"\\n\"]],[]],null]],[]],[[[41,[28,[37,2],[[30,4],[30,7]],null],[[[1,\"        \"],[8,[39,4],[[24,0,\"u--m__b__lg u--m__t__md u--m__r\"]],[[\"@additional\",\"@promise\",\"@text\",\"@variant\"],[\"block\",[30,8],[28,[37,5],[\"account.overview.subscription_overview.reactivate_plan\"],null],\"proceed\"]],null],[1,\"\\n\"],[41,[30,9],[[[1,\"          \"],[8,[39,6],[[24,0,\"u--m__r u--text--right u--block u--p__t\"],[4,[38,7],[\"click\",[30,10]],null]],[[\"@href\",\"@text\"],[\"https://later.com/product-training/\",[28,[37,5],[\"account.overview.subscription_overview.help\"],null]]],null],[1,\"\\n\"]],[]],null]],[]],[[[41,[30,11],[[[1,\"        \"],[8,[39,8],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@feature\",\"@location\",\"@text\"],[\"plans\",\"subscription overview\",[28,[37,5],[\"shared_phrases.upgrade_plan\"],null]]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,8],[[24,0,\"u--m__r qa--subscription__button--changePlan\"],[4,[38,7],[\"click\",[30,12]],null]],[[\"@feature\",\"@location\",\"@text\",\"@variant\"],[\"plans\",\"subscription overview\",[28,[37,5],[\"account.overview.subscription_overview.change_plan\"],null],\"outline\"]],null],[1,\"\\n      \"]],[]]]],[]]]],[]]]],[]],[[[1,\"      \"],[8,[39,8],[[24,0,\"u--m__r qa--settings__button--upgrade\"]],[[\"@feature\",\"@location\",\"@text\"],[[52,[30,13],\"trialPlansSnapshot\",\"plans\"],\"subscription overview\",[28,[37,5],[\"shared_phrases.upgrade_plan\"],null]]],null],[1,\"\\n\"]],[]]]],[]],null]],[]]]]]],[\"@isAccountOwner\",\"@subscription\",\"@hasActiveTrial\",\"@hasActiveCancelledSubscription\",\"@canShowCancelTrial\",\"@cancelTrial\",\"@canReactivatePlan\",\"@reactivatePlan\",\"@isNewSubscriber\",\"@trackClickedTraining\",\"@canUpgrade\",\"@trackChangePlan\",\"@isFreeEligibleForTrial\"],false,[\"section/item-action\",\"if\",\"and\",\"not\",\"shared/ui/button\",\"t\",\"shared/link\",\"on\",\"shared/button/upgrade\"]]",
    "moduleName": "settings/components/subscription-overview/action.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});